import '../styles/Contact.css';
import React, { useEffect } from 'react';
import { FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';


const Contact = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <section className="contact-section" id="contact">
      {/* <h2 data-aos="fade-up">Contact Us</h2> */}
      <div className="contact-container" data-aos="fade-up" data-aos-delay="100">
        <div className="contact-image" data-aos="fade-up">
          <img src="/images/contact_image.jpg" alt="Contact Icon" />
        </div>

        <form className="contact-form">
          <input type="text" placeholder="Your Name" required />
          <input type="email" placeholder="Your Email" required />
          <textarea placeholder="Your Message" rows="5" required></textarea>
          <button type="submit">Send Message</button>
        </form>
        <div className="contact-info">
          <div className="contact-info-row">
            <div className="info-box">
              <FaMapMarkerAlt className="icon" />
              <p>
                8B, Gopal Nagar Society,<br />
                Vishwambhar Enclave, Hafeezpet,<br />
                Hyderabad, Telangana– 500085- <br /> +91 8985756339
              </p>
            </div>
            <div className="info-box">
              <FaEnvelope className="icon" />
              <p>support@cveysolutions.in</p>
            </div>
          </div>

        </div>



      </div>
    </section>
  );
};

export default Contact;

